import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue';
import { MenuItem } from '@/util/menu';
import GMenuItem from '@/components/util/MenuItem.vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenuGroup',
  props: {
  miniVariant: { type: Boolean, required: false, default: false },
  menuItems: { type: Array as PropType<Array<MenuItem>>, required: false, default: () => [] },
  title: { type: [String, Object] as PropType<string|TranslateResult>, required: true },
  icon: { type: String, required: true },
  filledIcon: { type: String, required: false, default: undefined },
},
  emits: ['menu-expand'],
  setup(__props, { emit }) {

const props = __props;





const group = ref(false);

const clicked = () => emit('menu-expand');


return { __sfc: true,props, emit, group, clicked, GMenuItem }
}

})